import { Fragment } from 'react';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/login/Login.page';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Header from './components/layout/header/Header';
import Menu from './components/menu/Menu';
import { DashboardPage } from './pages/dashboard/Dashboard.page';
import { EspecialidadesBrowse } from './pages/especialidades/EspecialidadesBrowse.page';
import { EspecialidadesForm } from './pages/especialidades/EspecialidadesForm.page';
import { TriageBrowse } from './pages/triage/TriageBrowse.page';
import { TriageForm } from './pages/triage/TriageForm.page';
import { RegisterMedico } from './pages/register/RegisterMedico.page';
import { MedicoPending, MedicoRechazado } from './pages/login/MedicoStatusMessage.page';
import { MedicosBrowse } from './pages/medicos/MedicosBrowse.page';
import { AdminMedico } from './pages/medicos/MedicoAdmin.page';
import { Calendario } from './pages/calendario/Calendario.page';
import { LoginApp } from './pagesApp/Login.app';
import { WizardApp } from './pagesApp/Wizard.app';
import { RegisterApp } from './pagesApp/Register.app';
import { MenuApp } from './pagesApp/Menu.app';
// import ProtectedApp from './auth/ProtectedApp';
import { ParamsBrowse } from './pages/params/ParamsBrowse.page';
import { ParamsForm } from './pages/params/ParamsForm.page';
import { TurnosPendientesApp } from './pagesApp/TurnosPendientes.app';
import { TurnoPage } from './pages/turnos/Turno.page';
import { TurnosBrowse } from './pages/turnos/TurnosBrowse.page';
import { PacientesBrowse } from './pages/pacientes/PacientesBrowse.page';
import { PedirAyuda } from './pages/ayuda/PedirAyuda.page';
import { AyudaApp } from './pagesApp/Ayuda.app';
import { TurnoTermsApp } from './pagesApp/TurnoTerms.app';
import { TurnosPasadosApp } from './pagesApp/TurnosPasados.app';
import { CancelarTurnoApp } from './pagesApp/CancelarTurno.app';
import { VideoLlamadaApp } from './pagesApp/VideoLlamada.app';
import { ChangePassPage } from './pages/pass/ChangePass.page';
import { ForgotPassPage, ForgotPassValidatePage } from './pages/pass/ForgotPass.page';
import { PerfilApp } from './pagesApp/Perfil.app';
import { LandingPage } from './landing/Landing.page';
import { ChangePassApp } from './pagesApp/ChangePass.app';
import { ForgotPassApp, ForgotPassValidateApp } from './pagesApp/ForgotPass.app';
import { PrivacyPolicyPage, TermsAndConditionsPage } from './legals/TermsAndConditions.component';
import { PacientePage } from './pages/pacientes/Paciente.page';

function App() {

  const queryClient = new QueryClient()
  
  return (
		<BrowserRouter>
		<AuthProvider>
			<QueryClientProvider client={queryClient}>
				<Toaster/>
				<Routes>
					<Route path='/' element={<LandingPage />} />
					<Route path='/landing' element={<LandingPage />} />
					<Route path='/legals/terms-and-conditions' element={<TermsAndConditionsPage />} />
					<Route path='/legals/privacy-policy' element={<PrivacyPolicyPage />} />
					<Route path='/med/login' element={<LoginPage />} />
					<Route path='/med/registerm/pending' element={<MedicoPending />} />
					<Route path='/med/registerm/rechazado' element={<MedicoRechazado />} />
					<Route path='/app/login' element={<LoginApp />} />
					<Route path='/app/register/:dni' element={<RegisterApp />} />
					<Route path='/app/forgot-pass/generate' element={<ForgotPassApp />} />
					<Route path='/app/forgot-pass/validate/:dni' element={<ForgotPassValidateApp />} />

					<Route path='/' element={<Outlet />}>
						<Route path='/med/forgot-pass/send-code' element={<ForgotPassPage />} />
						<Route path='/med/forgot-pass/validate/:dni' element={<ForgotPassValidatePage />} />
						<Route path='/med/registerm' element={<RegisterMedico />} />
					</Route>
					<Route element={<ProtectedRoute />}>
						<Route path='/' element={<Outlet />}>
							<Route path='/app/wizard' element={<WizardApp />} />
							<Route path='/app/menu' element={<MenuApp />} />
							<Route path='/app/turnos-pendientes' element={<TurnosPendientesApp />} />
							<Route path='/app/turnos-pasados' element={<TurnosPasadosApp />} />
							<Route path='/app/cancelar-turno' element={<CancelarTurnoApp />} />
							<Route path='/app/perfil' element={<PerfilApp />} />
							<Route path='/app/ayuda' element={<AyudaApp />} />
							<Route path='/app/turno-terms' element={<TurnoTermsApp />} />
							<Route path='/app/video-llamada/:turnoId' element={<VideoLlamadaApp />} />
							<Route path='/app/change-pass' element={<ChangePassApp />} />
						</Route>

						<Route path='/' element={
							<Fragment>
								<Header />
								<Menu />
								<Outlet />
							</Fragment>
						}>
							<Route path='/med/dashboard' element={<DashboardPage />} />
							<Route path='/med/especialidades' element={<EspecialidadesBrowse />} />
							<Route path='/med/especialidades/new' element={<EspecialidadesForm />} />
							<Route path='/med/especialidades/:id' element={<EspecialidadesForm />} />

							<Route path='/med/triage' element={<TriageBrowse />} />
							<Route path='/med/triage/new' element={<TriageForm />} />
							<Route path='/med/triage/:id' element={<TriageForm />} />

							<Route path='/med/params' element={<ParamsBrowse />} />
							<Route path='/med/params/:id' element={<ParamsForm />} />

							<Route path='/med/pacientes' element={<PacientesBrowse />} />
							<Route path='/med/paciente/:dni' element={<PacientePage />} />
							
							<Route path='/med/admin/medicos' element={<MedicosBrowse />} />
							<Route path='/med/admin/medicos/:dni' element={<AdminMedico />} />
							<Route path='/med/perfil' element={<AdminMedico />} />

							<Route path='/med/calendario' element={<Calendario />} />
							<Route path='/med/turno/:id' element={<TurnoPage />} />
							<Route path='/med/turnos' element={<TurnosBrowse />} />

							<Route path='/med/ayuda' element={<PedirAyuda />} />
							<Route path='/med/change-pass' element={<ChangePassPage />} />
						</Route>
					</Route>
				</Routes>
			</QueryClientProvider>
	  	</AuthProvider>
	</BrowserRouter>
  );
}

export default App;
